import React from "react";
import { NURSE_FORM_STEPS } from "./nurseAssessmentFormConstants";

interface NurseFormStepperBarProps {
    activeStep: number | null;         // 0-based
    onStepClick: (index: number) => void;
    title?: string;
    steps?: ReadonlyArray<(typeof NURSE_FORM_STEPS)[number]>;
    startIndex?: number;
}

const NurseFormStepperBar: React.FC<NurseFormStepperBarProps> = ({
    activeStep,
    onStepClick,
    title,
    steps = NURSE_FORM_STEPS,
    startIndex = 0,
}) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.45rem",
                marginBottom: "0.55rem",
                padding: "0.5rem 0.7rem",
                background: "#fff",
                borderRadius: 8,
                border: "1px solid #e2e8f0",
                flexWrap: "wrap",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            }}
        >
            {title && (
                <div style={{ fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "#475569" }}>
                    {title}
                </div>
            )}
            <div style={{ display: "flex", gap: "0.35rem", flexWrap: "wrap" }}>
                {steps.map((step, index) => {
                const absoluteIndex = startIndex + index;
                const isActive = absoluteIndex === activeStep;
                const isCompleted = activeStep !== null && absoluteIndex < activeStep;

                return (
                    <React.Fragment key={step.label}>
                        <button
                            type="button"
                            onClick={() => onStepClick(absoluteIndex)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.35rem",
                                padding: "0.3rem 0.65rem",
                                borderRadius: 16,
                                border: isActive
                                    ? "1.5px solid #1d4ed8"
                                    : isCompleted
                                        ? "1.5px solid #f97316"
                                        : "1.5px solid #e2e8f0",
                                background: isActive
                                    ? "#eff6ff"
                                    : isCompleted
                                        ? "#fff7ed"
                                        : "#f8fafc",
                                color: isActive
                                    ? "#1d4ed8"
                                    : isCompleted
                                        ? "#c2410c"
                                        : "#64748b",
                                fontWeight: isActive ? 700 : 500,
                                fontSize: "0.74rem",
                                cursor: "pointer",
                                transition: "all 0.15s ease",
                                outline: "none",
                                whiteSpace: "nowrap",
                            }}
                            title={`Go to step ${absoluteIndex + 1}: ${step.label}`}
                        >
                            {/* Step number badge */}
                            <span
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: 16,
                                    height: 16,
                                    borderRadius: "50%",
                                    background: isActive
                                        ? "#1d4ed8"
                                        : isCompleted
                                            ? "#f97316"
                                            : "#cbd5e1",
                                    color: "#fff",
                                    fontSize: "0.6rem",
                                    fontWeight: 700,
                                    flexShrink: 0,
                                }}
                            >
                                {isCompleted ? <i className="pi pi-check" style={{ fontSize: "0.5rem" }} /> : absoluteIndex + 1}
                            </span>

                            {/* Icon */}
                            <i className={step.icon} style={{ fontSize: "0.72rem" }} />

                            {/* Label */}
                            {step.label}
                        </button>

                        {/* Connector line between steps */}
                        {index < steps.length - 1 && (
                            <div
                                style={{
                                    alignSelf: "center",
                                    width: 12,
                                    height: 2,
                                    background: activeStep !== null && absoluteIndex < activeStep ? "#f97316" : "#e2e8f0",
                                    borderRadius: 2,
                                    flexShrink: 0,
                                }}
                            />
                        )}
                    </React.Fragment>
                );
                })}
            </div>
        </div>
    );
};

export default NurseFormStepperBar;
